import React, { Component } from "react";
import Toplist from "../Toplist/Toplist";
import "./Home.css";

class Home extends Component {
  render() {
    return (
      <div className="home">
        <h1>Tervetuloa Laina-apu.fi sivustolle.</h1>
        <p>Laina-apu auttaa lainan hakemisessa. Lue <a href="/blogi/" title="Laina-apu blogi">Laina-apu blogista</a> viimeisimmät vinkit laina-asioihin tai katso sivustolle viimeksi lisätyt <a href="/lainat/" title="Lainatarjoukset">lainatarjoukset</a>.</p>
      	<Toplist />
        <h2>Opi lisää lainoista</h2>
      	<p>Laina-apu auttaa tutustumaan eri lainatuotteisiin ja siihen, mitä ne pitävät sisällään ja mitkä ovat niiden kulut. Näin ollen osaat tehdä päätöksen siitä, mikä on paras lainamuoto sinulle ja sinun tilanteeseesi. Lainoja on olemassa monenlaisia ja niitä tarvitaan eri tilanteisiin. Laina apu pyrkii auttamaan sinua tietämään lisää siitä, mikä laina sopii parhaiten sinun tilanteeseesi.</p>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home/Home.jsx